<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>Document Upload</h2>
    <button mat-icon-button fxLayoutAlign="end center" (click)="close(false)">
        <mat-icon aria-label="Close" class="headerIconButton">close</mat-icon>
    </button>
</div>

<mat-dialog-content style="max-height: 95%; padding: 0 !important;">
    <form [formGroup]="documentFormGroup" (ngSubmit)="saveDocumentDetails(submitBtn)" novalidate autocomplete="off">
        <mat-card class="mainStepperCard">
            <mat-card-content class="mainStepperCardContent" style="background: #f2f2f2;">
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>{{studentDocumentType}}</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.gt-md="20px">
                            <mat-form-field fxFlex="50%" fxFlex.lt-lg="100%" [hintLabel]="allowedUploadDocumentTypes">
                                <ngx-mat-file-input #fileAttachment formControlName="fileAttachment" placeholder="Choose File" [accept]="allowedUploadDocumentTypes" autofilled="true"></ngx-mat-file-input>
                                <button mat-icon-button matSuffix *ngIf="!fileAttachment.empty" (click)="fileAttachment.clear($event)">
                                    <mat-icon>clear</mat-icon>
                                </button>
                                <mat-icon matSuffix *ngIf="fileAttachment.empty" class="suffixIcon">folder</mat-icon>
                                <mat-error *ngIf="documentFormGroup.get('fileAttachment')?.hasError('required')"> Please select a file </mat-error>
                                <mat-error *ngIf="documentFormGroup.get('fileAttachment')?.hasError('maxContentSize')">
                                    The total size must not exceed {{ documentFormGroup.get('fileAttachment')?.getError('maxContentSize').maxSize | byteFormat }}
                                    ({{ documentFormGroup.get('fileAttachment')?.getError('maxContentSize').actualSize | byteFormat }}).
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field fxFlex="50%" fxFlex.lt-lg="100%" [disabled]="!allowMultipleOfType">
                                <mat-label>Description</mat-label>
                                <input matInput placeholder="Description" formControlName="description" maxlength="255">
                            </mat-form-field>
                        </div>
                    </mat-card-content>
                </mat-card>
            </mat-card-content>
            <mat-divider class="dividerColor"></mat-divider>
            <mat-card-actions fxLayoutAlign="end center">
                <button class="mat-raised-button dialogActionButton" mat-button (click)="close(false)" type="button">Cancel</button>
                <button class="mat-raised-button dialogActionButton" mat-button color="primary" type="submit" [disabled]="!documentFormGroup.dirty || documentFormGroup.invalid" #submitBtn>Save</button>
            </mat-card-actions>
        </mat-card>
    </form>
</mat-dialog-content>
